// src/store/languageSlice.js
import { createSlice } from "@reduxjs/toolkit";

const languageSlice = createSlice({
  name: "language",
  initialState: {
    // code → display name, e.g. { en: 'English', de: 'Deutsch' }
    map: {},
  },
  reducers: {
    setLanguageMap(state, action) {
      // action.payload is an object like { en: 'English', de: 'Deutsch' }
      state.map = action.payload;
    },
  },
});

export const { setLanguageMap } = languageSlice.actions;
export default languageSlice.reducer;
